<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="330px">
            <v-card>
                <v-card-title>
                    <span class="headline">
                        Line Service
                    </span>
                </v-card-title>
                <v-card-text>
                    Make sure you want to upgrade the line service
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="primary"
                        outlined
                        @click="closeModal()">
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="submit()">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: 'LineModal',

    data () {
        return {
            dialog: false
        }
    },

    methods: {
        closeModal () {
            this.dialog = false
        },

        openModal () {
            this.dialog = true
        },

        async submit () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('line/update')
            if (res && res.data && res.data.status === 'ok') {
                this.closeModal()
                this.$store.dispatch('setLoading', false)
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
